// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__18nEQ","bigColWidth":"Table_bigColWidth__33-Kw","biggerColWidth":"Table_biggerColWidth__4Dxae","row":"Table_row__2J5w4","col":"Table_col__3hjGH"};